import type { FC } from 'react';
import { Grid, Typography, Breadcrumbs } from '@material-ui/core';
import ChevronRightIcon from '../icons/ChevronRight';

const PanelTitle: FC<{
  title: string;
  subTitlePrim?: string;
  subTitleSec?: string;
}> = ({ title, subTitlePrim = '', subTitleSec = '' }) => (
  <Grid item>
    <Typography color="textPrimary" variant="h5">
      {title}
    </Typography>
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<ChevronRightIcon fontSize="small" />}
      sx={{ mt: 1 }}
    >
      {subTitlePrim && (
        <Typography color="textPrimary" variant="subtitle2">
          {subTitlePrim}
        </Typography>
      )}
      {subTitleSec && (
        <Typography color="textSecondary" variant="subtitle2">
          {subTitleSec}
        </Typography>
      )}
    </Breadcrumbs>
  </Grid>
);

export default PanelTitle;
